module.exports = __webpack_public_path__ + "static/media/4.13029157.svg";